import { render, staticRenderFns } from "./UsersNew.vue?vue&type=template&id=68ea39b0&scoped=true&lang=pug&"
import script from "./UsersNew.vue?vue&type=script&lang=ts&"
export * from "./UsersNew.vue?vue&type=script&lang=ts&"
import style0 from "./UsersNew.vue?vue&type=style&index=0&id=68ea39b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ea39b0",
  null
  
)

export default component.exports